module.exports = __webpack_public_path__ + "assets/images/GBP10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/GBP10.png
// module id = 1379
// module chunks = 1